import { gql } from 'urql';

import { PRODUCT } from '../client';

export const REOPEN_ROUTE = gql`
  mutation ${PRODUCT}RouteReopen($input: RouteReopenInput!) {
    reopenRoute(input: $input) {
      route {
        id
        stopTime
      }
      userErrors {
        __typename
      }
    }
  }
`;
